import { QueryClientProvider } from '@tanstack/react-query'
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { TranslationProvider } from 'i18nano'
import { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { queryClient } from 'shared/api/core/tanstack-query-config'
import {
	FALLBACK_LANGUAGE,
	getInitialLanguage,
	translations,
} from 'shared/lib/i18n'
import ru from 'shared/lib/i18n/translations/ru.json'
import { LanguageSynchronizer } from 'shared/lib/i18n/LanguageSynchronizer'
import { Toaster } from 'sonner'
import { TelegramProvider } from './TelegramProvider'

export function Providers({ children }: { children: React.ReactNode }) {
	return (
		<Suspense>
			<ErrorBoundary fallback={ru.errors.unexpected}>
				<QueryClientProvider client={queryClient}>
					<TranslationProvider
						translations={translations.common}
						fallback={FALLBACK_LANGUAGE}
						language={getInitialLanguage()}
						transition={true}
					>
						<LanguageSynchronizer />
						<TelegramProvider>{children}</TelegramProvider>

						<Toaster
							position='top-right'
							richColors
							visibleToasts={1}
							duration={1500}
							closeButton={true}
							// Push toasts below Telegram's fullscreen controls.
							// --header-safe-top is 0 outside fullscreen, so these
							// collapse to sonner's normal 24px / 16px gaps.
							offset={{ top: 'calc(var(--header-safe-top) + 24px)' }}
							mobileOffset={{
								top: 'calc(var(--header-safe-top) + 16px)',
							}}
						/>
					</TranslationProvider>

					{/* <ReactQueryDevtools initialIsOpen={false} /> */}
				</QueryClientProvider>
			</ErrorBoundary>
		</Suspense>
	)
}
